import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export const FadeIn = ({
  children,
  delay = 0,
  className = ''
}: {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}) => <motion.div initial={{
  opacity: 0,
  y: 20
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true,
  margin: '-20px'
}} transition={{
  duration: 0.6,
  delay
}} className={`will-change-transform ${className}`} data-id="element-245">
    {children}
  </motion.div>;
export const Button = ({
  href,
  children,
  variant = 'primary',
  className = ''
}: {
  href: string;
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  className?: string;
}) => {
  const baseStyle = 'inline-flex items-center justify-center px-4 md:px-8 py-4 rounded-full font-bold transition-all duration-300 transform hover:scale-105 active:scale-95 shadow-xl text-center leading-tight break-words max-w-full';
  const variants = {
    primary: 'bg-gradient-to-r from-gold-400 via-gold-500 to-gold-600 text-navy-900 hover:shadow-gold-500/40 relative overflow-hidden group',
    secondary: 'bg-navy-800 text-white border border-navy-600 hover:bg-navy-700 hover:border-gold-500/50'
  };
  return <motion.a href={href} className={`${`${baseStyle} ${variants[variant]} ${className}`} pt-[16px] pb-[16px]`} whileHover={{
    y: -2
  }} animate={variant === 'primary' ? {
    boxShadow: ['0 10px 15px -3px rgba(212, 175, 55, 0.1)', '0 10px 25px -3px rgba(212, 175, 55, 0.4)', '0 10px 15px -3px rgba(212, 175, 55, 0.1)'],
    scale: [1, 1.02, 1]
  } : {}} transition={variant === 'primary' ? {
    duration: 2,
    repeat: Infinity,
    ease: 'easeInOut'
  } : {}} data-id="element-246">
      {variant === 'primary' && <div className="absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-white/30 to-transparent -translate-x-full group-hover:animate-shine" data-id="element-247" />}
      <span className="relative z-10 font-[800]" data-id="element-248">{children}</span>
    </motion.a>;
};
export const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 16,
    seconds: 48
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (num: number) => num.toString().padStart(2, '0');
  const TimeUnit = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-249">
      <div className="relative bg-gradient-to-b from-navy-700 to-navy-900 px-3 md:px-5 py-3 rounded-xl border border-gold-500/30 shadow-[0_0_15px_rgba(212,175,55,0.1)] overflow-hidden min-w-[64px] md:min-w-[80px]" data-id="element-250">
        {/* Glossy overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-transparent via-white/5 to-white/10 pointer-events-none" data-id="element-251" />

        <div className="relative flex justify-center items-center h-10 md:h-14 overflow-hidden" data-id="element-252">
          <motion.span key={value} initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} exit={{
          y: -20,
          opacity: 0
        }} transition={{
          type: 'spring',
          stiffness: 300,
          damping: 30
        }} className="text-3xl md:text-5xl font-mono font-black text-gold-400 tracking-tighter" data-id="element-253">
            {format(value)}
          </motion.span>
        </div>
      </div>
      <span className="text-[10px] md:text-xs text-gold-500/70 uppercase font-bold tracking-widest mt-2" data-id="element-254">
        {label}
      </span>
    </div>;
  return <div className="flex items-center justify-center space-x-3 md:space-x-5" data-id="element-255">
      <TimeUnit value={timeLeft.hours} label="horas" data-id="element-256" />
      <div className="text-gold-500/50 text-2xl md:text-4xl font-black self-start mt-4 md:mt-6" data-id="element-257">
        :
      </div>
      <TimeUnit value={timeLeft.minutes} label="minutos" data-id="element-258" />
      <div className="text-gold-500/50 text-2xl md:text-4xl font-black self-start mt-4 md:mt-6" data-id="element-259">
        :
      </div>
      <TimeUnit value={timeLeft.seconds} label="segundos" data-id="element-260" />
    </div>;
};